module.exports = __webpack_public_path__ + "static/media/EastHampton_9.15298dd5.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_9.JPG
// module id = 246
// module chunks = 0